import { render, staticRenderFns } from "./Denounce-search.vue?vue&type=template&id=3b6eea24&scoped=true"
import script from "./Denounce-search.vue?vue&type=script&lang=js"
export * from "./Denounce-search.vue?vue&type=script&lang=js"
import style0 from "./Denounce-search.vue?vue&type=style&index=0&id=3b6eea24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6eea24",
  null
  
)

export default component.exports